window.$ = $ = jQuery;

require("./lib/js-cookie.min.js");
require("./cart.js");
require("./cart-count.js");
require("./product-detail.js");
require("./categories-bar.js");
require("./checkout.js");
require("./woocommerce-general.js");
require("./contact.js");
require("./faq.js");
require("./menu.js");
require("./product-finder.js");
require("./reviews.js");
require("./drl-popup.js");
require("./swiper.js");
require("./sticky-add-to-cart.js");
require("./my-account.js");

import './product-card'
import './product-bundle'
import './tabcordion'
import "./search"
import "./mini-cart"
// const search = new Search()

$(function () {
	$("form#gform_3").each(function () {
		const action = $(this).attr("action").split("#")[0];

		$(this).attr("action", action);
	});

	// Feedback form
	const feedbackToggle = $('.feedback-trigger, .feedback-popup .close-btn');
	const feedbackPopUp = $('.feedback-popup');

	feedbackToggle.on('click', function () {
		feedbackPopUp.toggle();
	});

});

$('.cookie-settings').on('click', function () {
	if (typeof Cookiebot !== 'undefined') {
		Cookiebot.show();
	}
});

// Add transition/animation for 'added to cart' message
if ($("body").hasClass("added-to-cart") && !$("body").hasClass("woocommerce-account")) {

	// selectors
	const addedToCartDiv = $("#added-to-cart-msg");
	const closeAddedToCartDiv = $("#added-to-cart-msg .close");

	// remove hide class
	addedToCartDiv.removeClass("hide");

	// close message when clicked on close button
	closeAddedToCartDiv.on("click", function () {
		addedToCartDiv.addClass("hide");
	});

	// hide message after 6 seconds
	setTimeout(function () {
		addedToCartDiv.addClass("hide");
	}, 6000);
}

$(".productpromotion button #close").on("click", function () {
	$(".productpromotion").removeClass("open");
});

window.addEventListener('DOMContentLoaded', () => {
	if ($(window).width() < 769) {
		$(".advice-content").removeAttr("open");
	} else {
		$(".advice-content").attr("open", true);
	}
});

$(window).resize(function () {
	if ($(window).width() < 769) {
		$(".advice-content").removeAttr("open");
	} else {
		$(".advice-content").attr("open", true);
	}
}); 